import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { compose } from 'recompose';

import getSymbolFromCurrency from 'currency-symbol-map';
import EmbeddedRegister from 'components/EmbeddedRegister';
import BudgetNode from 'components/Budgets/BudgetNode';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import ZeroStateView from 'components/ZeroStateView';
import FormControl from '@material-ui/core/FormControl';
import QMonthNavigator from 'components/QMonthNavigator'
import QButton from 'components/QButton';
import QDialogs from 'components/QDialogs';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { DateTime } from 'luxon';
// import { List as ImmutableList } from 'immutable';
// import { isAcme } from 'isAcme';
import { cacheableObject } from 'utils/objectCache';

require('intersection-observer');

const styles = ({ defaults, palette, typography }) => ({
  root: {
    position: 'relative', // insures that header's drop shadow is on top, not obscured
    zIndex: 0,
    minWidth: defaults.content.pageMinWidth,
    backgroundColor: palette.background.default,
  },
  barSection: {
    backgroundColor: palette.greyScale[7],
  },
  content: {
    margin: '2px auto',
    width: '100%',
    padding: `20px ${defaults.content.paddingLeftMobile}px`,
    '@media (min-width: 769px)': {
      padding: `20px ${defaults.content.paddingLeft}px`,
    },
  },
  header: {
    minHeight: defaults.headers.headerHeight,
    borderBottom: `1px solid ${palette.greyScale[5]}`,  // in lieu of the shadow, use a border
    backgroundColor: palette.greyScale[7],
    zIndex: 2,
  },
  headerContent: {
    width: '100%',
    paddingLeft: defaults.content.paddingLeftMobile,
    paddingRight: defaults.content.paddingRightMobile,
    '@media (min-width: 769px)': {
      paddingLeft: defaults.content.paddingLeft,
      paddingRight: defaults.content.paddingRight,
    },

    minHeight: defaults.headers.headerHeight,
  },
  pathButton: {
    ...typography.body2,
    background: 'transparent',
    border: 'none',
    outline: 0,
    color: palette.blue3,
    textTransform: 'none',
    minWidth: 10,
    marginTop: 7,
    padding: 0,
    cursor: 'pointer',
    '&:disabled': {
      color: palette.greyScale[2],
    },
    '&.isLastLeaf': {
      cursor: 'default',
    },
  },
  pathDivider: {
    ...typography.body2,
    padding: '6px 6px 6px 5px',
    color: palette.greyScale[0],
  },
  transactionsHeader: {
    ...typography.body1,
    color: palette.greyScale[2],
  },
});

/*
const regFieldsOrder = isAcme
  ? new ImmutableList(['select', 'account', 'postedOn', 'state', 'payee', 'category', 'tags', 'expense', 'income', 'amount', 'attachment', 'save', 'close', 'menu'])
  : new ImmutableList(['select', 'account', 'postedOn', 'payee', 'category', 'expense', 'income', 'amount', 'attachment', 'save', 'close', 'menu']);
*/

class BudgetEmbedded extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      transactionsBarStuck: false,
      budgetMonthEditable: true, // (props.budgetTreeNodes && props.budgetTreeNodes.size >= 1),
    };
  }

  componentDidMount = () => {
    const budgetsBarSentinel = document.querySelector('#budgetsBarSentinel');

    if (budgetsBarSentinel && typeof IntersectionObserver !== 'undefined') {
      this.budgetsBarObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // this.setState({ budgetsBarStuck: false });
          } else {
            // this.setState({ budgetsBarStuck: true });
          }
        });
      }, {
        root: null,
        rootMargin: `-${this.props.theme.defaults.headers.headerHeight}px 0px 0px 0px`,
        threshold: 0,
      });
      this.budgetsBarObserver.observe(budgetsBarSentinel);
    }

    const transactionsBarSentinel = document.querySelector('#transactionsBarSentinel');
    if (transactionsBarSentinel && typeof IntersectionObserver !== 'undefined') {
      this.transactionsBarObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.setState({ transactionsBarStuck: false });
          } else {
            this.setState({ transactionsBarStuck: true });
          }
        });
      }, {
        root: null,
        threshold: 0,
      });
      this.transactionsBarObserver.observe(transactionsBarSentinel);
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.budgetTreeNodes !== this.props.budgetTreeNodes) {
      // this.setState({ budgetMonthEditable: nextProps.budgetTreeNodes && nextProps.budgetTreeNodes.size >= 1 });
    }
  }

  componentWillUnmount = () => {
    if (this.budgetsBarObserver) {
      this.budgetsBarObserver.disconnect();
    }
    if (this.transactionsBarObserver) {
      this.transactionsBarObserver.disconnect();
    }
  };

  render() {
    const {
      theme,
      classes,
      navigationPath,
      isLoading,
      goNextMonth,
      goPrevMonth,
      goThisMonth,
      handleNavigationClick,
      handleBudgetChange,
      startDate,
      budgets,
      budget,
      transactions,
      budgetTreeNodes,
      accountIds,
      budgetsCreation,
    } = this.props;

    let nodeIndex = 0;

    if (isLoading) { return null; }

    return (
      <div
        className={classes.root}
        id="container"
      >
        <AppBar
          position="sticky"
          elevation={0}
          className={classes.header}
        >
          <Toolbar
            className={classes.headerContent}
            style={{
              display: 'flex',
              flexWrap: 'nowrap',
              justifyContent: 'flex-end',
            }}
          >
            <span
              style={{ flexGrow: 1 }}
            >
              <button
                id="budgets-title"
                className={classNames(classes.pathButton, { isLastLeaf: !navigationPath })}
                color="primary"
                disabled={!navigationPath}
                onClick={() => handleNavigationClick(null)}
                type="button"
              >
                {budget && budget.name}
              </button>

              {navigationPath && navigationPath.map((node, i) => (
                <span key={node.key}>
                  <span className={classes.pathDivider}>/</span>
                  <button
                    id={`budgets-path-${i}`}
                    className={classNames(classes.pathButton, { isLastLeaf: i === navigationPath.length - 1 })}
                    color="primary"
                    onClick={() => handleNavigationClick(node)}
                    type="button"
                  >
                    {node.displayLabel}
                  </button>
                </span>
              ))}
            </span>

            {budgets && budgets.size > 1 &&
            <FormControl id="budgets-page-dropdown">
              <Select
                id="budgets-page-select"
                style={{
                  margin: 'auto 20px auto 20px',
                  flexShrink: 0,
                  color: theme.palette.greyScale[2],
                  paddingLeft: 8,
                  fontSize: 13,
                }}
                value={budget ? `${budget.id}` : ''}
                onChange={handleBudgetChange}
              >
                {budgets && budgets.valueSeq().map((theBudget, index) => (
                  <MenuItem
                    id={`budgets-select-${index}`}
                    value={theBudget.id}
                    key={theBudget.id}
                  >
                    {theBudget.name}
                    {this.props.budgets
                    && theBudget.currency
                    && this.props.budgets.reduce((set, aBudget) => { set.add(aBudget.currency); return set; }, new Set()).size > 1
                    && ` (${getSymbolFromCurrency(theBudget.currency)})`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            }

            {budgetsCreation &&
              <>
                <QButton onClick={this.props.onDelete}>
                  <DeleteIcon style={{ marginRight: 7 }}/>
                  {`Delete ${budget.name}`}
                </QButton>

                {this.state.budgetMonthEditable &&
                  <QButton onClick={this.props.onEdit} color="secondary">
                    <EditIcon style={{ marginRight: 7 }}/>
                    {`Edit ${budget.name} `}
                  </QButton>
                }
              </>
            }

            <QMonthNavigator
              date={DateTime.fromJSDate(startDate)}
              onPreviousClick={goPrevMonth}
              onCurrentClick={goThisMonth}
              onNextClick={goNextMonth}
            />

          </Toolbar>
        </AppBar>
        <div
          className={classes.content}
          id="budgetItems"
        >
          <div
            id="budgetsBarSentinel"
            style={{
              height: 1,
              visibility: 'hidden',
            }}
          />

          {budgetTreeNodes && budgetTreeNodes.size > 0 ?
            <Paper className={classes.barSection}>
              {budgetTreeNodes.map((node) => (
                <React.Fragment key={node.key}>
                  <BudgetNode
                    index={nodeIndex++} // eslint-disable-line no-plusplus
                    key={node.key}
                    style={{ padding: 20 }}
                    budget={budget}
                    node={node}
                    showChildLink={!navigationPath}
                    editInPlace={!budgetsCreation}
                    isParent
                  />

                  {navigationPath && navigationPath.length > 0 && node.children &&
                  node.children.map((childNode) => (
                    <BudgetNode
                      index={nodeIndex++} // eslint-disable-line no-plusplus
                      key={childNode.key}
                      style={{ padding: 20, paddingLeft: 60 }}
                      showChildLink
                      budget={budget}
                      node={childNode}
                      editInPlace={!budgetsCreation}
                    />
                  ))
                  }
                </React.Fragment>
              ))}
            </Paper>
            :
            <ZeroStateView
              primary=" "
              secondary="There are no budget items to display."
            />
          }
        </div>

        <AppBar
          position="sticky"
          color="default"
          elevation={this.state.transactionsBarStuck ? 5 : 0}
          className={classes.header}
          onClick={(event) => {
            event.stopPropagation();
            const element = document.querySelector('#transactionsBarSentinel');
            if (element && window.scrollTo) {
              window.scrollTo({ left: 0, top: element.offsetTop, behavior: 'smooth' });
            }
          }}
        >
          <Toolbar
            className={classes.headerContent}
          >
            <div
              id="budgets-transactions-heading"
              className={classes.transactionsHeader}
            >
              {'Transactions for '}
              <span style={{ fontWeight: 500, color: theme.palette.greyScale[1] }}>
                {navigationPath && navigationPath.length > 0 ? navigationPath[navigationPath.length - 1].displayLabel : budget && budget.name}
              </span>
            </div>

          </Toolbar>
        </AppBar>
        <div
          id="transactionsBarSentinel"
          style={{
            height: 1,
            visibility: 'hidden',
          }}
        />

        {transactions && transactions.size > 0 ?
          <div
            id="transactions"
            className={classes.content}
            style={{ height: 568 }}
          >
            <EmbeddedRegister
              name="Reg_Budgets"
              overrideTxns={cacheableObject(transactions)}
              currency={budget && budget.currency}
              showControls
              hideDividers
              hideSearch
              noNew
              bottomMargin={0}
              accountIds={cacheableObject(accountIds)}
            />
          </div>
          :
          <ZeroStateView
            primary=" "
            secondary="There are no transactions to display."
          />
        }

        <div style={{ height: theme.spacing(3) }}>&nbsp;</div>
      </div>
    );
  }
}

BudgetEmbedded.propTypes = {
  theme: PropTypes.object,
  classes: PropTypes.object,
  budgets: PropTypes.object,
  budgetsCreation: PropTypes.bool,
  budget: PropTypes.object,
  budgetTreeNodes: PropTypes.object,
  goNextMonth: PropTypes.func,
  goPrevMonth: PropTypes.func,
  goThisMonth: PropTypes.func,
  handleNavigationClick: PropTypes.func,
  handleBudgetChange: PropTypes.func,
  isLoading: PropTypes.bool,
  transactions: PropTypes.object,
  accountIds: PropTypes.object,
  navigationPath: PropTypes.array,
  startDate: PropTypes.any,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

export default compose(
  QDialogs(),
  withStyles(styles, { withTheme: true }),
)(BudgetEmbedded);
